import { Component } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'vx-solutions',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    <section class="solutions-page">
      <div class="container">
        <header class="page-hero reveal">
          <span class="eyebrow">Soluzioni</span>
          <h1>Soluzioni VaulTriX</h1>
          <p class="lead">Smart locker modulari per Smart City, enti pubblici e operatori turistici.</p>
          <p>VaulTriX offre una piattaforma unica che si adatta a diversi scenari urbani e turistici. Ogni soluzione combina hardware certificato, software cloud e gestione tramite app per utenti finali e operatori.</p>
          <p>Scopri come possiamo supportare il tuo contesto.</p>
        </header>

        <div class="solution-grid">
          @for (solution of solutions; track solution.title; let i = $index) {
            <article class="solution-card reveal" [class.featured]="i === 0">
              <div class="icon-badge dark"><lucide-icon [name]="solution.icon" [size]="26" /></div>
              <h2>{{ solution.title }}</h2>
              <ul>
                @for (item of solution.items; track item) {
                  <li>{{ item }}</li>
                }
              </ul>
            </article>
          }
        </div>
      </div>
    </section>
  `,
  styles: [`
    .solutions-page {
      min-height: calc(100vh - 78px);
      padding: 84px 0 96px;
      color: #21094f;
      background:
        radial-gradient(circle at 8% 12%, rgba(84,216,232,.14), transparent 22rem),
        radial-gradient(circle at 92% 16%, rgba(103,58,183,.18), transparent 26rem),
        linear-gradient(135deg, #f7f2ff, #eef8ff);
    }
    .page-hero {
      max-width: 900px;
      margin-bottom: 34px;
    }
    h1 {
      margin: 10px 0 12px;
      font-family: "Space Grotesk", sans-serif;
      font-size: clamp(2.4rem, 6vw, 5rem);
      line-height: 0.95;
      letter-spacing: -0.06em;
    }
    .lead {
      margin: 0 0 20px;
      font-size: 1.2rem;
      font-weight: 900;
    }
    .page-hero p:not(.lead) {
      max-width: 780px;
      margin: 0 0 16px;
      color: #3d266b;
      font-size: 1.07rem;
      font-weight: 750;
      line-height: 1.65;
    }
    .solution-grid {
      display: grid;
      grid-template-columns: 1.15fr 0.85fr;
      gap: 22px;
      align-items: stretch;
    }
    .solution-card {
      position: relative;
      overflow: hidden;
      min-height: 330px;
      padding: 28px;
      border-radius: 30px;
      background:
        linear-gradient(145deg, rgba(255,255,255,.88), rgba(255,255,255,.62)),
        radial-gradient(circle at 90% 10%, rgba(84,216,232,.22), transparent 16rem);
      border: 1px solid rgba(64,40,106,.12);
      box-shadow: var(--vx-shadow);
    }
    .solution-card.featured {
      grid-row: span 2;
      color: white;
      background:
        radial-gradient(circle at 85% 12%, rgba(84,216,232,.25), transparent 18rem),
        linear-gradient(145deg, #241044, #40286a);
    }
    .solution-card.featured .icon-badge {
      background: rgba(255,255,255,.12);
      border: 1px solid rgba(255,255,255,.16);
    }
    .solution-card.featured li,
    .solution-card.featured h2 {
      color: white;
    }
    .icon-badge {
      margin-bottom: 24px;
    }
    h2 {
      margin: 0 0 18px;
      font-family: "Space Grotesk", sans-serif;
      font-size: clamp(1.4rem, 3vw, 2rem);
      line-height: 1;
    }
    ul {
      display: grid;
      gap: 12px;
      margin: 0;
      padding: 0;
      list-style: none;
    }
    li {
      position: relative;
      padding-left: 22px;
      color: #3d266b;
      font-size: 1rem;
      font-weight: 800;
      line-height: 1.45;
    }
    li::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0.62em;
      width: 8px;
      height: 8px;
      border-radius: 99px;
      background: #54d8e8;
    }
    @media (max-width: 900px) {
      .solution-grid { grid-template-columns: 1fr; }
      .solution-card.featured { grid-row: auto; }
    }
  `]
})
export class SolutionsComponent {
  protected readonly solutions = [
    {
      icon: 'landmark',
      title: 'Smart City e amministrazioni',
      items: [
        'Locker diffusi in punti strategici della città (stazioni, parcheggi di interscambio, fermate bus).',
        'Riduzione del bagaglio in strada e maggiore percezione di sicurezza.',
        'Dati aggregati sui flussi turistici e sull’utilizzo degli spazi.'
      ]
    },
    {
      icon: 'landmark',
      title: 'Enti pubblici e spazi culturali',
      items: [
        'Locker per musei, poli fieristici, teatri e centri congressi.',
        'Gestione automatizzata di zaini e valigie in ingresso.',
        'Riduzione del personale dedicato al guardaroba.',
        'Maggiore controllo sugli accessi grazie a log digitali e notifiche.'
      ]
    },
    {
      icon: 'hotel',
      title: 'Operatori turistici e hospitality',
      items: [
        'Soluzioni per hotel, B&B, ostelli e property manager.',
        'Check-in e check-out flessibili grazie a locker per chiavi e bagagli.',
        'Servizio aggiuntivo per ospiti in arrivo o in partenza.',
        'Possibilità di monetizzare il deposito bagagli'
      ]
    }
  ];
}
